export default "__VITE_ASSET__CCYdVfbP__"